import { CircularProgress } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { File } from '../common/models/files';
import { fetchFile } from '../common/store/files';
import { AppState, appStore, fileSelector } from '../common/store/store';


export const FileLoader = (props: {
    id: number,
    children: (model: File) => React.ReactNode;
}) => {

    const file = useSelector((state: AppState) => fileSelector.selectById(state, props.id));

    React.useEffect(() => {
        if (props.id && props.id != file?.id) {
            appStore.dispatch(fetchFile(props.id));
        }
    }, [props.id]);

    return file ? props.children(file) : <><CircularProgress size={20} /></>;
};
